import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * @typedef {import("../../../../hooks/teacher/students/useGetStudentReportById").QuestItem} QuestItem
 */

/**
 * @typedef {object} StudentType
 * @property {string} name
 * @property {string} studentId
 * @property {string | number} age
 * @property {string} email
 * @property {number} progress
 * @property {number} avgScore
 * @property {number} totalQuests
 */

/**
 * Quest Table Row Component
 * @param {{quest: QuestItem, studentId: string | number, student: StudentType}} props
 */
const QuestTableRow = ({ quest, studentId, student }) => {
  const navigate = useNavigate();

  return (
    <tr
      style={{ cursor: "pointer" }}
      onClick={() =>
        navigate(`/teacher/student/${studentId}/${quest.quest_id}`, {
          state: {
            student: student,
          },
        })
      }
    >
      <td>
        <div className="custom-name-cell">
          <span className="custom-name">{quest.quest_name}</span>
        </div>
      </td>
      <td>{quest.episodes}</td>
      <td>{quest.percentage}%</td>
      <td>{quest.due_date ? quest.due_date.split(" ")[0].split("T")[0] : "-"}</td>
      <td>
        <button
          className="custom-detail-btn"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/teacher/student/${studentId}/${quest.quest_id}`, {
              state: {
                student: student,
              },
            });
          }}
        >
          <i className="bi bi-three-dots-vertical" />
        </button>
      </td>
    </tr>
  );
};

export default QuestTableRow;
